import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { DocumentDetailContext } from "../contexts/DocumentDetailContext";
import { EditRowItem, RowItem, TableHeader } from "./Components";
import "./Extraction.css";
import { Add } from "@mui/icons-material";


let allNormalizedKeys = ["Patient Name", "Patient Date of Birth", "To", "Address", "Phone Number"];

let dataExtractKeysList = {
    "Patient Name": "patientName",
    "Patient Date of Birth": "dateOfBirth",
    "Address": "address",
    "Phone Number": "phone_number",
    "To": "provider_details",
}

const Extraction = (props) => {

    const { data = {}, setDocumentData, duplicateDocumentView, setDataSave, isSave, previousData, setBoundingCoordinates, updateDocumentSearchString } = useContext(DocumentDetailContext);
    const [extractionData, setExtractionData] = useState([]);
    const [extractionKeys, setExtractionKeys] = useState([]);
    const [selectedObj, setSelectedObj] = useState({});
    const [isFieldModified, setFieldModify] = useState(false);
    const [newItem, setNewItem] = useState([]);

    useEffect(() => {
        let extraction = JSON.parse(JSON.stringify(data?.Entity_Details?.extraction || {}))
        let availableKeys = Object.keys(extraction).map(m => extraction[m].normalized);
        let finalData = allNormalizedKeys.reduce((acc, m) => {
            if (Object.hasOwn(extraction, dataExtractKeysList[m])) {
                let temp = { ...extraction[dataExtractKeysList[m]], id: dataExtractKeysList[m] }
                acc.push(temp);
            }
            return acc;
        }, []);
        let previousCards =  finalData.filter(m => !newItem.includes(m.normalized))
        let newlyAddedCards = newItem.map(m => {
            return finalData.filter(n => m == n.normalized)[0];
        })
        setExtractionKeys([...availableKeys]);
        setExtractionData(JSON.parse(JSON.stringify([...previousCards, ...newlyAddedCards])));
    }, [data]);

    useEffect(() => {
        if(isFieldModified && !isSave) {
            setFieldModify(false);
            setSelectedObj({});
            setNewItem([]);
        }
    }, [isSave])


    const handleEdit = (row) => {
        setSelectedObj({ ...row });
    }

    const handleChange = (key, obj) => {
        let res = JSON.parse(JSON.stringify(data));
        if (selectedObj?.id != dataExtractKeysList[obj.normalized]) {
            if(key) {
                let temp = [...newItem.filter(m => res.Entity_Details.extraction[key].normalized != m)];
                if(!newItem.includes(obj.normalized)) {
                    temp.push(obj.normalized)
                }
                setNewItem([...temp])
                delete res.Entity_Details.extraction[key];
            } else setNewItem([...newItem, obj.normalized]);
            res.Entity_Details.extraction[dataExtractKeysList[obj.normalized]] = { ...obj, id:  dataExtractKeysList[obj.normalized] };
            setSelectedObj({...obj, id:  dataExtractKeysList[obj.normalized]})
        } else {
            res.Entity_Details.extraction[key] = { ...obj };
            setSelectedObj({...obj, })
        }
        setDataSave(true);
        setDocumentData(JSON.parse(JSON.stringify(res)));
        setFieldModify(true);
    }

    const handleCancel = () => {
        let tempData = {...data};
        let extraction = tempData.Entity_Details.extraction;
        extraction[selectedObj.id] = previousData.Entity_Details.extraction[selectedObj.id];
        tempData.Entity_Details.extraction = {...extraction};
        setDocumentData(JSON.parse(JSON.stringify(tempData)));
        setSelectedObj({});
    }

    const addNewItem = () => {
        let temp = [...extractionData];
        let obj = {
            normalized: "",
            confidence: 1.0,
            key: "",
            value: "",
            modified: true,
            user_added_card: true
        }
        temp.push(obj);
        setExtractionData([...temp]);
        setSelectedObj(obj);
    }

    const onRowClick = (obj) => {
        const {value_vertices, page, modified } = obj;
        if(modified || page == 0) {
            updateDocumentSearchString(obj.value);
            setBoundingCoordinates([]);
            return 0;
        }
        
        const xArr = (value_vertices || []).map((c) => c.x);
        const yArr = (value_vertices || []).map((c) => c.y);
    
        const x1 = xArr?.length && Math.min(...xArr);
        const x2 = xArr?.length && Math.max(...xArr);
        const y1 = yArr?.length && Math.min(...yArr);
        const y2 = yArr?.length && Math.max(...yArr);
        let temp = [{
            page,
            color: "blue",
            vertices: {
                x1: x1 || 0,
                y1: y1 || 0,
                x2: x2 || 0,
                y2: y2 || 0
            }
        }];
        setBoundingCoordinates([...temp]);
        updateDocumentSearchString("");
    }

    return <div className="specific-extraction" style={{ marginBottom: "20px" }}>
        <div className="extraction-table-title">Extracted Information</div>
        <TableContainer sx={{ background: "var(--bg-card-primary)", boxShadow: "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)" }}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableHeader />
                </TableHead>
                <TableBody>
                    {extractionData.map((row) => (
                        selectedObj?.id == row?.id ?
                            <EditRowItem
                                handleChange={handleChange}
                                data={row}
                                availableOptions={extractionKeys}
                                keyOrders={allNormalizedKeys}
                                documentData={data}
                                isSave={isSave}
                                handleCancel={handleCancel}
                            /> : <RowItem data={row} disableEdit={props.disableEdit || duplicateDocumentView } handleEdit={() => handleEdit(row)} onRowClick={onRowClick}/>
                    ))}
                </TableBody>
            </Table>
            {extractionKeys?.length != allNormalizedKeys?.length && !duplicateDocumentView && <div className="add-new-item" onClick={addNewItem}>
                <Add />
                <div>Add New Key/Parameter</div>
            </div>}
        </TableContainer>
    </div>
}

export default Extraction;